
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SiteType } from 'enums/SiteType';
import { PointerModel } from './Distribution.Api.Models.Pointer';
import { ServerModel } from './Distribution.Api.Models.Server';
import { Model, ModelProperty } from 'models/Model';


export class SiteModel extends Model<SiteModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'site.property.id', isHidden: true },
		{ name: 'externalId', type: 'string', languageString: 'site.property.externalId' },
		{ name: 'productPlanId', type: 'guid', languageString: 'site.property.productPlanId' },
		{ name: 'vatNo', type: 'string', languageString: 'site.property.vatNo' },
		{ name: 'status', type: 'SiteStatus', languageString: 'site.property.status' },
		{ name: 'redesignStatus', type: 'RedesignStatus', languageString: 'site.property.redesignStatus' },
		{ name: 'type', type: 'SiteType', languageString: 'site.property.type' },
		{ name: 'created', type: 'Date', languageString: 'site.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'site.property.deleted', isHidden: true },
		{ name: 'hostname', type: 'string', languageString: 'site.property.hostname' },
		{ name: 'pointers', type: 'PointerModel[]', languageString: 'site.property.pointers', isHidden: true, isArray: true, isObject: true, new: () => { return new PointerModel }, properties: () => { return PointerModel.classProperties } },
		{ name: 'server', type: 'ServerModel', languageString: 'site.property.server', isHidden: true, isObject: true, new: () => { return new ServerModel }, properties: () => { return ServerModel.classProperties } },
		{ name: 'taskId', type: 'string', languageString: 'site.property.taskId' },
		{ name: 'autoDeleteDate', type: 'Date', languageString: 'site.property.autoDeleteDate' },
		{ name: 'message', type: 'string', languageString: 'site.property.message' },
		{ name: 'databaseUser', type: 'string', languageString: 'site.property.databaseUser' },
		{ name: 'databasePassword', type: 'string', languageString: 'site.property.databasePassword' },
		{ name: 'databaseName', type: 'string', languageString: 'site.property.databaseName' },
		{ name: 'databaseServer', type: 'string', languageString: 'site.property.databaseServer' },
		{ name: 'replacesSite', type: 'SiteModel', languageString: 'site.property.replacesSite', isHidden: true, isObject: true, new: () => { return new SiteModel }, properties: () => { return SiteModel.classProperties } },
		{ name: 'replacesSiteId', type: 'guid', languageString: 'site.property.replacesSiteId' },
		{ name: 'replacedBySite', type: 'SiteModel', languageString: 'site.property.replacedBySite', isHidden: true, isObject: true, new: () => { return new SiteModel }, properties: () => { return SiteModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public externalId: string;
	public productPlanId?: string;
	public vatNo: string;
	public status: SiteStatus;
	public redesignStatus: RedesignStatus;
	public type: SiteType;
	public created?: Date;
	public deleted?: Date;
	public hostname: string;
	public pointers: PointerModel[];
	public server?: ServerModel;
	public taskId: string;
	public autoDeleteDate?: Date;
	public message: string;
	public databaseUser: string;
	public databasePassword: string;
	public databaseName: string;
	public databaseServer: string;
	public replacesSite?: SiteModel;
	public replacesSiteId?: string;
	public replacedBySite?: SiteModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.externalId = '';
		this.productPlanId = undefined;
		this.vatNo = '';
		this.status = 0;
		this.redesignStatus = 0;
		this.type = 0;
		this.created = undefined;
		this.deleted = undefined;
		this.hostname = '';
		this.pointers = [];
		this.server = undefined;
		this.taskId = '';
		this.autoDeleteDate = undefined;
		this.message = '';
		this.databaseUser = '';
		this.databasePassword = '';
		this.databaseName = '';
		this.databaseServer = '';
		this.replacesSite = undefined;
		this.replacesSiteId = undefined;
		this.replacedBySite = undefined;
		
	}
	getProperties(){
		return SiteModel.classProperties;
	}
}

export enum SiteStatus{
	AwaitingResponse = 0,
	Working = 1,
	Stopped = 2,
	Completed = 3,
	Failed = 4,
	ActivatingRedesign = 5,
	ChangingDefaultPointer = 6,
	Migrating = 20,
	MigrationFailed = 21,
	InProcessOfBeingDeleted = 22
}
export namespace SiteStatus {
	export function getKeys(): Map<SiteStatus, string> {
		return new Map([[0, 'AwaitingResponse'], [1, 'Working'], [2, 'Stopped'], [3, 'Completed'], [4, 'Failed'], [5, 'ActivatingRedesign'], [6, 'ChangingDefaultPointer'], [20, 'Migrating'], [21, 'MigrationFailed'], [22, 'InProcessOfBeingDeleted']]);
	}
}
export enum RedesignStatus{
	None = 0,
	CreatingLegacyPointer = 1,
	DeletingOldPointers = 2,
	AwaitingPointerDeletion = 11,
	CreatingTestAddresses = 12,
	CreatingProductionAddresses = 13,
	DeletingTemporaryPointers = 14
}
export namespace RedesignStatus {
	export function getKeys(): Map<RedesignStatus, string> {
		return new Map([[0, 'None'], [1, 'CreatingLegacyPointer'], [2, 'DeletingOldPointers'], [11, 'AwaitingPointerDeletion'], [12, 'CreatingTestAddresses'], [13, 'CreatingProductionAddresses'], [14, 'DeletingTemporaryPointers']]);
	}
}
